export { default as ENVIRONMENTS } from './environments';
